import './product-gallery.scss';

import { sendTracking } from '../../js/tracking';

class ProductGallery {
    constructor (element, options) {
        const defaults = {
            resizeTimeout: 150,
            initAttr: 'data-productgallery',
            trackingAttr: 'data-trackingcategory',
            slidesAttr: 'slides',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$slider = element;
        this.$slidesWrapper = this.$slider.querySelector('[' + this.settings.initAttr + '="' + this.settings.slidesAttr + '"]');
        this.$slides = this.$slider.querySelectorAll('[' + this.settings.initAttr + '="' + this.settings.slideAttr + '"]');
        this.trackingCategory = this.$slider.getAttribute(this.settings.trackingAttr);
        this.currentIndex = 0;
    }

    initialize () {
        const calculateHeight = ($slides) => {
            $slides.style.height = 'auto';
            const height = $slides.offsetHeight;
            $slides.style.height = height + 'px';
            return height + 'px';
        };

        const initSlider = (Slider) => {
            let timer = null;
            let clicked = false;
            const imageSlider = new Slider(this.$slider, {
                autoHeight: false,
                breakpoints: null,
                speed: 500,
                indicators: false,
                prevnext: true,
                calculateHeight: false,
                slidesPerView: 1,
                initAttr: 'data-productgallery',
                onInit: (Obj, $current, currentIndex) => {
                    $current.classList.add('is--big');
                    timer = window.setTimeout(() => {
                        const newHeight = calculateHeight(this.$slidesWrapper);
                        this.$slider.style.height = newHeight;
                    }, 500);
                },
                onSlideChange: ($slider, slider, $currentSlide, currentIndex) => {
                    const $bigs = $slider.querySelectorAll('.is--big');

                    for (let i = 0; i < $bigs.length; i++) {
                        const $current = $bigs[i];
                        $current.classList.remove('is--big');
                    }

                    $currentSlide.classList.add('is--big');

                    if (this.trackingCategory !== null) {
                        let direction;
                        if (currentIndex > this.currentIndex) {
                            direction = 'forth';
                        } else {
                            direction = 'back';
                        }

                        if (clicked === false) {
                            sendTracking({
                                category: this.trackingCategory,
                                action: 'swipe',
                                label: 'slide_' + direction + '_' + (currentIndex + 1)
                            });
                        }

                        this.currentIndex = currentIndex;
                        clicked = false;
                    }
                },
                onClickPrev: (currentIndex) => {
                    clicked = true;

                    if (this.trackingCategory !== null) {
                        sendTracking({
                            category: this.trackingCategory,
                            action: 'click',
                            label: 'btn_back_' + (currentIndex + 1)
                        });
                    }
                },
                onClickNext: (currentIndex) => {
                    clicked = true;

                    if (this.trackingCategory !== null) {
                        sendTracking({
                            category: this.trackingCategory,
                            action: 'click',
                            label: 'btn_forth_' + (currentIndex + 1)
                        });
                    }
                },
                onSlide: () => {
                    clearTimeout(timer);
                    timer = window.setTimeout(() => {
                        const newHeight = calculateHeight(this.$slidesWrapper);
                        this.$slider.style.height = newHeight;
                    }, 100);
                }
            });

            this.$slider.API = imageSlider;
        };

        import('../../components/slider/slider').then(({ Slider }) => {
            initSlider(Slider);
        });
    }
}

export { ProductGallery };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productGalleries = $context.querySelectorAll('[data-productgallery="slider"]');

        if ($productGalleries.length > 0) {
            for (let i = 0; i < $productGalleries.length; i++) {
                const $productGallery = new ProductGallery($productGalleries[i]);
                $productGallery.initialize();
            }
        }
    }
});
